import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

export const ScrollableContainer = styled(Box).attrs({
  px: 16,
})`
  border: ${p => `1px solid ${p.theme.colors.heavyLineOutline}`};
  border-radius: 5px;
  overflow: scroll;
  max-height: 250px;
`;
export const RowContainer = styled(Box).attrs({
  horizontal: true,
  align: 'center',
  py: 13,
})``;
